<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import HarborManager from '@components/contract/harbor-manager'
import addCountry from '@components/contract/addCountry'
import { HotTable } from '@handsontable-pro/vue'
import Handsontable from 'handsontable'
import 'handsontable/dist/handsontable.full.css'
import 'handsontable-pro/languages/es-MX'
import { axiosGetPost } from '@router/axiosGetPost'
import axios from 'axios'
import XLSX from 'xlsx'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import { suggested } from './suggested.js'

function DangerRenderer(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments)
  td.style.color = 'red'
  td.style.background = '#F3EEEC'
}

var dataStyle = []

export default {
  page: {
    title: 'Spreadsheet',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, HotTable, HarborManager, addCountry,Multiselect },
  directives: {
    focus: {
      inserted(el) {
        el.focus()
      },
    },
  },
  data() {
    return {
      //Agregado estatico
      dataSuggested: suggested,
      openAddSurcharge: false,
      destinationType: [],
      showOptionsSelectedSurcharges: false,
      selectedSurcharge: [],
      allSelectedSurcharge: false,
      newCharge: '',
      newSurcharge: {},
      module: '',
      checkCountry: '',
      data: {},
      allSelected: false,
      indeterminate: false,
      dataChargeModel: '',
      addDataCountry: {},
      addCountries: '',
      dataCountriesOrigin: [],
      dataCountriesDestination: [],
      dataCountry: {},
      dataTypeDestination: ['Freight', 'Otro'],
      dataCalculationType: suggested['calculation_types'],
      valueSuggested: 5,
      fileDownloaded: false,
      //Fin Agregado estatico
      title: 'Processing Contract',
      items: [
        {
          text: 'Request',
          href: '/requests',
        },
        {
          text: 'Processing',
          active: true,
        },
      ],
      requestType: (this.$route.params.type || 'FCL').toUpperCase(),
      requestId: this.$route.params.id,
      preload: this.$route.query.preload,
      container: null,
      mousedown: false,
      success: false,
      tableSuccess: false,
      error: '',
      loadingSpreadsheet: true,
      loadingTable: true,
      tableLoaded: false,
      nameFile: null,
      corner: {},
      contract: {
        id: null,
        status: null,
        name: null,
        filename: null,
        validation: null,
        direction: null,
        company: null,
        user: null,
        operator: null,
        created: null,
      },
      action: {
        type: null,
        tagType: 'normal',
        displayTagType: 'NORMAL',
        tc: 0,
        color: 'table-success',
        tag: '',
        isTag: true,
      },
      spreadsheet: {},
      tags: {
        loading: true,
        root: {},
        current: {},
        path: [],
      },
      hotSettings: {
        licenseKey: '4d522-5237a-55f42-6653a-d1494',
        data: [],
        style: [],
        colHeaders: true,
        rowHeaders: true,
        manualColumnMove: true,
        manualRowMove: true,
        manualColumnResize: true,
        stretchH: 'all',
        width: '100%',
        height: 610,
        rowHeights: 23,
        contextMenu: true,
        language: 'es-MX',
        afterChange: this.afterChangeVue,
        afterRemoveRow: this.afterRemoveRow,
        afterCreateRow: this.afterCreateRow,
        afterCreateCol: this.afterCreateCol,
        afterRemoveCol: this.afterRemoveCol,
      },
      autoSaveSettings: {
        time: 0,
        reloadTime: 4,
        autoSave: false,
        completed: false,
      },
      validateRqProgress: {
        requestMapId: null,
        inCourse: 0,
        completed: 0,
      },
      showModal: false,
      modalComponent: 'Messages',
      modalTitle: {
        Messages: 'Mesagges',
        HarborManager: 'Harbor Manager',
        Details: 'Contract Details',
        similars: 'Similar contracts',
        TaosTads: 'TAOs & TADs',
        addCountry: '',
      },
      postprocessingMessages: [],
      addCountryOptions: {
        dataPlace: [],
        inputPlace: [],
        inputType: '',
      },
      suggestionsTab: {
        loading: false,
        success: false,
        error: '',
        similarContracts: [],
        numTrades: 0,
      },
      options: [],
      selectTaoTadBy:'MIN',
    }
  },
  watch: {
    $route: 'fetchData',
    'tags.path': 'getCurrentTags',

    selectedSurcharge: function () {
      if (this.selectedSurcharge.length > 1) {
        this.showOptionsSelectedSurcharges = true
      } else {
        this.showOptionsSelectedSurcharges = false
      }

      if (
        this.selectedSurcharge.length == this.dataSuggested.suggested.length
      ) {
        this.allSelectedSurcharge = true
      } else {
        this.allSelectedSurcharge = false
      }
    },
  },
  created() {
    this.fetchData()
  },
  mounted() {
    setInterval(() => this.incrementAS(), 1000)
  },

  methods: {
    onSearch(search, loading) {
      loading(true)
      // this.search(loading, search, this)
      axiosGetPost('post', 'contracts/OnSelects', {
        search: search,
        module: this.requestType,
        request_id: this.requestId,
      }).then((data) => {
        console.log(data)
        if (data.success) {
          this.options = data.data
          loading(false)
        } else {
        }
        return data
      })
    },
    changeType(key) {
      this.dataSuggested.suggested[key].ORIGIN = [{ id: null, name: null }]
      this.dataSuggested.suggested[key].DESTINY = [{ id: null, name: null }]
    },
    allSurcharges() {
      if (
        this.selectedSurcharge.length == this.dataSuggested.suggested.length
      ) {
        return (this.selectedSurcharge = [])
      }
      this.selectedSurcharge = []
      let countSurcharges = this.dataSuggested.suggested.length
      for (let step = 0; step < countSurcharges; step++) {
        this.selectedSurcharge.push(step)
      }
    },
    duplicateSurcharge(index) {
      //console.log(this.dataSuggested.suggested[index].ORIGIN);
      if (this.selectedSurcharge.length > 0 && index !== null) {
        let countSurcharges = this.selectedSurcharge.length
        for (let step = 0; step < countSurcharges; step++) {
          this.dataSuggested.suggested.push({
            charge:
              this.dataSuggested.suggested[this.selectedSurcharge[step]].charge,
            detail_charge:
              this.dataSuggested.suggested[this.selectedSurcharge[step]].detail_charge,
            DIFFERENTIATOR:
              this.dataSuggested.suggested[this.selectedSurcharge[step]]
                .DIFFERENTIATOR,
            destination_type:{
              id: this.dataSuggested.suggested[this.selectedSurcharge[step]]
                .destination_type.id,
              name: this.dataSuggested.suggested[this.selectedSurcharge[step]]
                .destination_type.name,
            },
            ORIGIN:
              this.dataSuggested.suggested[this.selectedSurcharge[step]].ORIGIN,
            DESTINY:
              this.dataSuggested.suggested[this.selectedSurcharge[step]]
                .DESTINY,
            calculationType: {
              id: this.dataSuggested.suggested[this.selectedSurcharge[step]]
                .calculationType.id,
              name: this.dataSuggested.suggested[this.selectedSurcharge[step]]
                .calculationType.name,
            },
            amount_mean:
              this.dataSuggested.suggested[this.selectedSurcharge[step]]
                .amount_mean,
            currency: this.dataSuggested.suggested[this.selectedSurcharge[step]].currency,
            count:
              this.dataSuggested.suggested[this.selectedSurcharge[step]].count,
            amount_cv:
              this.dataSuggested.suggested[this.selectedSurcharge[step]]
                .amount_cv,
          })
        }
        return (this.selectedSurcharge = [])
      } else {
        this.dataSuggested.suggested.push({
          charge: this.dataSuggested.suggested[index].charge,
          detail_charge: this.dataSuggested.suggested[index].detail_charge,
          DIFFERENTIATOR: this.dataSuggested.suggested[index].DIFFERENTIATOR,
          destination_type:{
            id: this.dataSuggested.suggested[index].destination_type.id,
            name: this.dataSuggested.suggested[index].destination_type.name,
          },
          ORIGIN: this.dataSuggested.suggested[index].ORIGIN,
          DESTINY: this.dataSuggested.suggested[index].DESTINY,
          calculationType: {
            id: this.dataSuggested.suggested[index].calculationType.id,
            name: this.dataSuggested.suggested[index].calculationType.name,
          },
          amount_mean: this.dataSuggested.suggested[index].amount_mean,
          currency:this.dataSuggested.suggested[index].currency,
          count: this.dataSuggested.suggested[index].count,
          amount_cv: this.dataSuggested.suggested[index].amount_cv,
          lower_limit: this.dataSuggested.suggested[index].lower_limit,
          upper_limit: this.dataSuggested.suggested[index].upper_limit,
        })
      }
    },
    deleteSurcharge(index) {
      if (this.selectedSurcharge.length > 1) {
        var array = this.selectedSurcharge.sort().reverse()
        array.forEach((x) => {
          console.log(x)
          this.dataSuggested.suggested.splice(x, 1)
        })
        this.selectedSurcharge = []
      } else {
        this.dataSuggested.suggested.splice(index, 1)
      }
    },
    addNewSurcharge() {
      this.dataSuggested.suggested.push({
        charge: null,
        DIFFERENTIATOR: 'Port',
        destination_type: { id: 3, name: 'freight' },
        ORIGIN: [{ id: null, name: null, clearfiel: 1 }],
        DESTINY: [{ id: null, name: null, clearfiel: 1 }],
        calculationType: { id: null, name: null },
        amount_mean: 0,
        currency: { id: 149, name: 'USD' },
        count: 'N/A',
        amount_cv: 'N/A',
        detail_charge: {color: "grey",info: "Manual"}
      })
    },
    showModalPlace(index, module, data) {
      if (this.dataSuggested.suggested[index].DIFFERENTIATOR == 'Country') {
        //console.log(this.dataSuggested['countries']);
        this.addCountryOptions = {
          dataPlace: this.dataSuggested['countries'],
          inputPlace:
            this.dataSuggested['suggested'][index][module.toUpperCase()],
          inputType: '',
          index: index,
        }
      } else {
        //console.log(this.dataSuggested['harbors']);
        this.addCountryOptions = {
          dataPlace: this.dataSuggested['harbors'],
          inputPlace:
            this.dataSuggested['suggested'][index][module.toUpperCase()],
          inputType: '',
          index: index,
        }
      }

      if (module == 'ORIGIN') {
        this.modalTitle.addCountry = 'Origin'
      } else {
        this.modalTitle.addCountry = 'Destination'
      }
      this.modalComponent = 'addCountry'
      this.showModal = true
    },
    fetchData() {
      // get contract's data
      let dateWf = moment()
      let date = dateWf.format('YYYY-MM-DD')
      let payload = {
        spreadsheetData: false,
        date: date, //  Para que se necesita??
        type: this.requestType,
        preload: this.preload,
      }
      this.loadingSpreadsheet = true
      let id = this.requestId
      let apiUrl = ''

      if (this.$route.name === 'contract_preprocess') {
        apiUrl = `/contracts/preprocess/${id}`
      } else if (this.$route.name === 'contract_preview') {
        apiUrl = `/contracts/${id}`
      } else {
        payload.spreadsheetData = true
        apiUrl = `/contracts/processing/${id}`
      }
      console.log('entra aqui', payload)
      axiosGetPost('post',apiUrl, payload).then((response) => {
        this.success = response.success
        if (this.success) {
          this.spreadsheet = response.spreadsheet
          this.tags.root = response.tag_tree
          this.validateRqProgress = response.validate_rq_progress
          this.getCurrentTags()
          this.getName(id)
          this.loadingSpreadsheet = false
          this.tags.loading = false
          this.evaluateOtherProgress()

          if ('contract' in response) {
            let c = response.contract
            this.contract.id = c.id
            this.contract.name = c.name
            this.contract.status = c.status
            this.contract.filename = c.filename
            this.contract.validation = c.validation
            this.contract.direction = c.direction
            this.contract.company = c.company
            this.contract.user = c.user
            this.contract.operator = c.operator
            this.contract.created = moment(c.created).format('LLL')
          }

          if ('postprocessing' in response) {
            this.setupTable(response.postprocessing)
            this.postprocessingMessages = response.messages
            this.tableLoaded = true
            this.tableSuccess = true
          }
        } else {
          this.error = response.error
        }
        this.loadingSpreadsheet = false
      })
    },
    getName(id) {
      axiosGetPost(
        'get',
        '/contracts/NameFile/' + id + '/' + this.requestType
      ).then((data) => {
        this.nameFile = data.data + '.xlsx'
        return data
      })
    },
    nextType(c) {
      let types = ['normal', 'self_contained', 'mixed']
      let displayTypes = ['NORMAL', 'SELF CTD', 'MIXED']
      this.action.tc = c === undefined ? (this.action.tc + 1) % types.length : c
      this.action.tagType = types[this.action.tc]
      this.action.displayTagType = displayTypes[this.action.tc]
    },
    getCurrentTags() {
      this.tags.current = this.tags.path.reduce(
        (current, key) => current[key].children,
        this.tags.root
      )
    },
    updateTagsPath(action, next) {
      if (
        action === 'push' &&
        Object.keys(this.tags.current[next].children).length > 0
      ) {
        this.tags.path.push(next)
      } else if (action === 'pop') {
        this.tags.path.pop()
      } else if (action === 'reset') {
        this.tags.path = []
      }
    },
    setAction: function (action, tag = null, color = '#ffffff') {
      this.action.type = action
      this.action.tag = tag
      this.action.color = color
      this.nextType(0)
    },
    first: function (s, i, j) {
      this.corner.s = s
      this.corner.i = i
      this.corner.j = j
    },
    last: function (s, i, j) {
      if (
        this.corner.s === undefined ||
        this.corner.i === undefined ||
        this.corner.j === undefined
      )
        return
      let is = [this.corner.i, i]
      let js = [this.corner.j, j]
      for (let i_ = Math.min(...is); i_ <= Math.max(...is); i_++) {
        for (let j_ = Math.min(...js); j_ <= Math.max(...js); j_++) {
          if (this.action.type === 'tag') {
            this.spreadsheet[s].sheet[i_][j_][
              this.action.isTag ? 'tag' : 'behavior'
            ] = this.action.tag
            this.spreadsheet[s].sheet[i_][j_][
              !this.action.isTag ? 'tag' : 'behavior'
            ] = undefined
            this.spreadsheet[s].sheet[i_][j_].color = this.action.color
            this.spreadsheet[s].sheet[i_][j_].type = this.action.tagType
          } else if (this.action.type === 'delete') {
            this.spreadsheet[s].sheet[i_][j_].color = this.action.color
            this.spreadsheet[s].sheet[i_][j_].tag = null
            this.spreadsheet[s].sheet[i_][j_].behavior = null
            this.spreadsheet[s].sheet[i_][j_].type = null
            this.spreadsheet[s].sheet[i_][j_].inherited = {}
          }
        }
      }
    },
    exportData: function () {
      this.loadingTable = true

      let apiUrl = `/contracts/postprocess`
      if (this.tableLoaded === true) {
        this.loadingTable = false
        return
      }

      let payload = {
        spreadsheet: this.spreadsheet,
        type: this.requestType,
      }

      axiosGetPost('post',apiUrl, payload)
        .then((response) => {
          if (response.success === true) {
            this.setupTable(response.data)
            this.postprocessingMessages = response.messages
            this.loadingTable = false
            this.tableLoaded = true
            this.tableSuccess = true
            this.autoSaveSettings.autoSave = true
            this.saveProgress()
          } else {
            this.loadingTable = false
            this.tableSuccess = false
            this.error = response.error
          }
        })
    },
    getSurchargeSuggestions() {
      // Si ya se cargo las sugerencias, no se activa otra vez.
      if (this.suggestionsTab.success || this.suggestionsTab.loading) {
        return
      }

      let payload = {
        table: this.hotSettings.data,
        requestId: this.requestId,
        requestType: this.requestType,
      }

      this.suggestionsTab.loading = true
      axiosGetPost('post','/contracts/get-surcharge-suggestions', payload)
        .then((response) => {
          console.log(response)
          this.dataCalculationType = response.calculation_types
          this.dataSuggested.calculation_types = response.calculation_types
          this.dataSuggested.currencies = response.currencies
          this.dataTypeDestination = response.type_destiny
          this.dataSuggested.harbors = response.harbors
          this.dataSuggested.countries = response.countries
          this.dataSuggested.type_destiny = response.type_destiny
          if (response.success) {
            this.dataSuggested = response
            this.suggestionsTab.similarContracts = response.res
            this.suggestionsTab.numTrades = response.num_trades
            this.suggestionsTab.success = true
          } else {
            this.dataSuggested.contract = response.contract
            this.suggestionsTab.similarContracts = response.res || []
            this.suggestionsTab.numTrades = response.num_trades || 0
            this.dataSuggested.similar = 0
            this.suggestionsTab.success = false
            this.suggestionsTab.error = response.error
          }
          this.suggestionsTab.loading = false
        })
    },
    reorderData(direction) {
      this.loadingTable = true
      let apiUrl = '/contracts/reorder'
      axiosGetPost('post',apiUrl, { table: this.hotSettings.data, direction })
        .then((response) => {
          if (response.success === true) {
            this.setupTable(response.data)
            this.loadingTable = false
            this.tableLoaded = true
            this.tableSuccess = true
          } else {
            this.loadingTable = false
            this.tableSuccess = false
            this.error = response.error
          }
        })
    },
    setupTable(table) {
      let headerOrder = []
      if (this.requestType === 'FCL') {
        headerOrder = [
          'ORIGIN',
          'DESTINY',
          'CHARGE',
          'CALCULATION TYPE',
          '20DV',
          '40DV',
          '40HC',
          '20RF',
          '40RF',
          '40HCRF',
          '40NOR',
          '45HC',
          '20FR',
          '40FR',
          '20OT',
          '40OT',
          'TYPE DESTINY',
          'CURRENCY',
          'CARRIER',
          'DIFFERENTIATOR',
          'VIA',
        ]
      } else if (this.requestType == 'LCL') {
        headerOrder = ['ORIGIN', 'DESTINY', 'CURRENCY', 'W/M', 'MIN']
      }

      let headers = Object.keys(table[0])
      headers = headerOrder.filter((val) => headers.includes(val))
      let data = [headers]
      let style = [Array(headers.length)]
      for (let r = 0; r < table.length; r++) {
        let dataRow = []
        let styleRow = []
        for (let h = 0; h < headers.length; h++) {
          let cell = table[r][headers[h]]
          let v = !!cell && typeof cell === 'object' ? cell.value : cell
          let s = !!cell && typeof cell === 'object' ? cell.style : null
          dataRow.push(v || null)
          styleRow.push(s || null)
        }
        data.push(dataRow)
        style.push(styleRow)
      }
      dataStyle = style
      this.hotSettings.data = data
    },
    addRow() {
      this.container = this.$refs.wrapper.hotInstance
      this.container.alter('insert_row', this.hotSettings.data.length)
    },
    downloadFile() {
      axiosGetPost('post', '/contracts/homologateFile', {
        request_id: this.requestId,
        module: this.requestType.toUpperCase(),
        spreadsheet: this.hotSettings.data,
      }).then((response) => {
        console.log(response)
        if (response.success === true) {
          let table = response.data
          // this.$emit('donwloadExcel')
          // A workbook is the name given to an Excel file
          var wb = XLSX.utils.book_new() // make Workbook of Excel
          var wscols = [{ wch: 35 }, { wch: 35 }, { wch: 10 }, { wch: 20 }]
          for (let i = wscols.length +1; i <= table.length; i++) {
            wscols.push({ wch: 10 })
          }
          var dataXLSX = XLSX.utils.json_to_sheet(table)
          dataXLSX['!cols'] = wscols
          XLSX.utils.book_append_sheet(wb, dataXLSX, 'Hoja1') // sheetAName is name of Worksheet
          XLSX.writeFile(wb, this.nameFile) // name of the file is 'book.xlsx'
          this.fileDownloaded = true
        } else {
          this.$toastr.e('Error Auto Save in Server. Error: ' + response.error)
        }
        return response
      })
    },
    incrementAS() {
      this.autoSaveSettings.time = this.autoSaveSettings.time + 1
      if (this.autoSaveSettings.time === this.autoSaveSettings.reloadTime) {
        this.autoSaveSettings.time = 0
        if (
          this.autoSaveSettings.autoSave === true &&
          this.tableLoaded === true
        ) {
          this.saveProgress()
        }
      }
    },
    afterRemoveRow(index, amount) {
      this.autoSaveSettings.autoSave = true
    },
    afterRemoveCol(index, amount) {
      this.autoSaveSettings.autoSave = true
    },
    afterCreateRow(index, amount) {
      this.autoSaveSettings.autoSave = true
    },
    afterCreateCol(index, amount) {
      this.autoSaveSettings.autoSave = true
    },
    afterChangeVue(changes, source) {
      this.autoSaveSettings.autoSave = true
    },
    saveProgress() {
      let dateWf = moment()
      let date = dateWf.format('YYYY-MM-DD')
      let id = this.$route.params.id

      axiosGetPost('post', '/requests/saveProgress', {
        data_excel: this.hotSettings.data,
        request_id: id,
        date: date,
        completed: this.autoSaveSettings.completed,
        module: this.requestType.toUpperCase(),
        preload: this.preload,
      }).then((data) => {
        this.autoSaveSettings.autoSave = false
        return data
      })
    },
    evaluateOtherProgress() {
      if (
        this.validateRqProgress.inCourse === 1 &&
        this.validateRqProgress.completed === 0
      ) {
        this.$swal({
          title: 'Deseas recuperar el progreso?',
          text: 'No se ha completado el proceso. Tus datos se respaldaron!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Si!',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.value) {
            // llamar al metodo que carga la data y habilitar this.tableLoaded = true una vez terminado
            this.loadingTable = true
            this.getDataAutoSave()
          }
        })
      } else if (
        this.validateRqProgress.inCourse === 0 &&
        this.validateRqProgress.completed === 1
      ) {
        this.$swal({
          title: 'TERMINADO. La data anterior no se puede cargar',
          text: 'El mapeo de éste contracto esta marcado como completado!',
        })
        // this.tableLoaded = false
        // this.tableSuccess = false
      } else if (
        this.validateRqProgress.inCourse === 0 &&
        this.validateRqProgress.completed === 0
      ) {
        // habilitar boton datatable exportData
        // this.tableLoaded = false
      }
    },
    getDataAutoSave() {
      let id = this.validateRqProgress.requestMapId
      axiosGetPost('post', '/contracts/getDataAS/' + id, {
        id: id,
        module: this.requestType.toUpperCase(),
      }).then((response) => {
        // console.log(response)
        if (response.success === true) {
          let table = response.data
          let h = table.length
          let w = table[0].length
          dataStyle = Array(h).fill(Array(w).fill(null))
          this.hotSettings.data = response.data
          // this.loadingTable = false
          this.tableLoaded = true
          this.tableSuccess = true
          // this.$swal('Datos Recuperados')
        } else {
          this.$toastr.e('Error Auto Save in Server. Error: ' + response.error)
        }
        return response
      })
    },
    mappingCompleted() {
      this.autoSaveSettings.completed = true
      this.autoSaveSettings.autoSave = false
      this.autoSaveSettings.reloadTime = 1000
      this.saveProgress()
      this.$router.push({
        name: 'Dashboard',
      })
    },
    confirmFinish() {
      if (this.fileDownloaded === false && this.preload == null) {
        this.$swal({
          title: 'No has descargado el archivo!',
          text: '¿Deseas descargar el archivo antes de salir?',
          type: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Si!',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.value) {
            this.downloadFile()
          } else {
            this.mappingCompleted()
          }
        })
      } else {
        this.$swal({
          title: '¿Deseas Finalizar?',
          text: 'No se guardaran los cambios!',
          type: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Si!',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.value) {
            this.mappingCompleted()
          }
        })
      }
    },
    downloadFileRequest(id) {
      let url = null
      if (this.requestType.toUpperCase() === 'FCL') {
        url = '/requests/downloadF/'
      } else {
        url = '/requestsLCL/downloadF/'
      }
      axiosGetPost('get', url + id).then((response) => {
        console.log(response)
        let data = response.data
        if (data.success === true) {
          var link = document.createElement('a')
          link.setAttribute('target', '_blank')
          link.href = data.url
          link.click()
          URL.revokeObjectURL(link.href)
        } else {
          this.$toastr.e(
            'Error Download. Status code: ' +
              data.status +
              ' Error: ' +
              data.error
          )
        }

        return data
      })
    },
    getCellTitle(cell) {
      const inheritedData = cell.inherited || {}
      let data = Object.keys(inheritedData).map(
        (v, i) => `${v}:${inheritedData[v]}`
      )
      data = [cell.tag || null, cell.behavior || null, ...data].filter(
        (e) => e != null
      )
      return data.join('\n')
    },
    saveSuggested() {
      let id = this.requestId
      this.$swal({
        title: 'Deseas cargar Las sugerencias?',
        text: 'Solo se cargaran las sugerencias!',
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Si!',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.value) {
          axiosGetPost('post', '/contracts/sugSurchargers', {
            request_id: id,
            suggested: this.dataSuggested.suggested,
          }).then((response) => {
            let data = response
            if (data.success === true) {
              this.$swal('Sugerencias Cargadas')
            } else {
              this.$toastr.e(
                'Error Load Suggested. Status code: ' +
                  data.status +
                  ' Error: ' +
                  data.error
              )
            }

            return data
          })
        }
      })
    },
    addSurchargeManually() {
      this.dataSuggested.suggested = []
      this.addNewSurcharge()
      this.suggestionsTab.success = true
    },
    processTaosTads(){
      this.loadingTable = true
      this.showModal = false
      axiosGetPost('post', 'contracts/processTaosTads', {
        spreadsheet: this.hotSettings.data, 
        valueBy: this.selectTaoTadBy,
        request_id:this.requestId
        }).then((data) => {
          console.log(data)
          if (data.success !== true) {
            this.$toastr.e('Error Proccess Taos & Tads' + data.error)
          } else {
            this.hotSettings.data = data.data
          }
          this.loadingTable = false
          return data
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-xl-12">
        <div class="card mt-3">
          <div class="card-body">
            <!-- <p>time: {{autoSaveSettings.time}} A.S: {{this.autoSaveSettings.autoSave}} T.L: {{this.tableLoaded}} L.T: {{this.loadingTable}} T.S: {{this.tableSuccess}} </p> -->

            <div
              v-if="loadingSpreadsheet"
              class="row align-items-center justify-content-center"
              style="height: 300px"
            >
              <div class="col-12 col-md-8 text-center">
                <b-spinner
                  label="Loading..."
                  variant="primary"
                  class="ml-3"
                ></b-spinner>
              </div>
            </div>

            <b-tabs v-else pills class="navtab-bg">
              <b-tab title="PRE-PROCESSING">
                <div>
                  <div class="button-list mb-2">
                    <button
                      class="btn btn-sm btn-primary my-0"
                      title="Contract Details"
                      @click="
                        modalComponent = 'Details'
                        showModal = true
                      "
                    >
                      <i class="uil uil-eye"></i>
                    </button>
                    <button
                      class="btn btn-sm my-0 btn-outline-primary"
                      title="Download Request File"
                      @click="downloadFileRequest($route.params.id)"
                    >
                      <i class="uil uil-cloud-download"></i>
                    </button>
                    <button
                      class="btn btn-sm my-0"
                      :class="[
                        action.isTag ? 'btn-outline-primary' : 'btn-primary',
                      ]"
                      @click="action.isTag = !action.isTag"
                    >
                      <i class="uil uil-tag"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-success my-0"
                      @click="nextType()"
                    >
                      {{ action.displayTagType }}
                    </button>
                    <button
                      class="btn btn-sm btn-danger my-0"
                      title="Delete Cluster"
                      @click="setAction('delete')"
                    >
                      <i class="uil uil-trash-alt"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-primary my-0"
                      @click="updateTagsPath('pop')"
                    >
                      <i class="uil uil-arrow-left"></i>
                    </button>
                    <button
                      v-for="(value, name, index) in tags.current"
                      :key="index"
                      class="btn btn-sm my-0"
                      :style="{
                        color:
                          action.tag === value.code ? '#ffffff' : value.color,
                        backgroundColor:
                          action.tag === value.code ? value.color : '#ffffff',
                        borderColor: value.color,
                      }"
                      @click.left.exact="
                        setAction('tag', value.code, value.color)
                      "
                      @click.right.exact.prevent="updateTagsPath('push', name)"
                    >
                      {{ name }}
                    </button>
                  </div>

                  <b-tabs v-if="success" pills class="navtab-bg">
                    <b-tab
                      v-for="(sheet, i) in spreadsheet"
                      :key="i"
                      :title="sheet.sheet_name"
                    >
                      <div
                        v-if="
                          sheet.sheet.length === 1 || !sheet.sheet[0].length
                        "
                        class="row align-items-center justify-content-center"
                        style="height: 300px"
                      >
                        <div class="col-12 col-md-8 text-center">
                          <feather
                            type="alert-triangle"
                            class="icon-xxl icon-dual-info"
                          ></feather>
                          <h6 class="text-muted">Empty sheet</h6>
                        </div>
                      </div>
                      <div
                        v-else
                        class="
                          table-spreadsheet
                          table-responsive
                          table-bordered
                          table-wrapper-scroll-y
                          my-custom-scrollbar
                        "
                      >
                        <table class="table mb-0">
                          <tbody>
                            <tr v-for="(row, j) in sheet.sheet" :key="j">
                              <td
                                v-for="(cell, k) in row"
                                :key="k"
                                :title="getCellTitle(cell)"
                                class="p-1"
                                :style="{
                                  backgroundColor:
                                    cell.tag !== undefined &&
                                    cell.tag !== 'glue'
                                      ? cell.color + '80'
                                      : cell.color + '35',
                                  borderTopColor:
                                    cell.tag !== undefined &&
                                    cell.tag !== 'glue'
                                      ? cell.color + '80'
                                      : cell.color + '35',
                                }"
                                @mousedown.left.exact="first(i, j, k)"
                                @mouseup.left.exact="last(i, j, k)"
                                @click.ctrl.exact="
                                  cell.edit = true
                                  cell.preprocess = false
                                "
                              >
                                <input
                                  v-if="cell.edit"
                                  v-model="cell.value"
                                  v-focus
                                  class="w-100"
                                  @keyup.enter="cell.edit = false"
                                  @blur="cell.edit = false"
                                />
                                <div v-else>
                                  <small>
                                    {{ cell.value }}
                                  </small>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </b-tab>
                  </b-tabs>

                  <div
                    v-else
                    class="row align-items-center justify-content-center"
                    style="height: 300px"
                  >
                    <div class="col-12 col-md-8 text-center">
                      <feather
                        type="frown"
                        class="icon-xxl icon-dual-info"
                      ></feather>
                      <h6 class="text-muted">{{ error }}</h6>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab title="POST-PROCESSING" @click="exportData">
                <div
                  v-if="loadingTable"
                  class="row align-items-center justify-content-center"
                  style="height: 300px"
                >
                  <div class="col-12 col-md-8 text-center">
                    <b-spinner
                      label="Loading..."
                      variant="primary"
                      class="ml-3"
                    ></b-spinner>
                  </div>
                </div>
                <div v-else>
                  <div v-if="tableSuccess">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="button-list mb-2">
                          <button
                            class="btn btn-sm btn-primary"
                            @click="addRow"
                          >
                            <i class="uil uil-plus"></i>
                            ADD ROW
                          </button>
                          <button
                            class="btn btn-sm btn-primary"
                            title="Harbor Manager"
                            @click="
                              modalComponent = 'HarborManager'
                              showModal = true
                            "
                          >
                            <i class="uil uil-anchor"></i>
                          </button>
                          <button
                            class="btn btn-sm"
                            :class="[
                              postprocessingMessages.length > 0
                                ? 'btn-danger'
                                : 'btn-primary',
                            ]"
                            title="See details"
                            @click="
                              modalComponent = 'Messages'
                              showModal = true
                            "
                          >
                            <i class="uil uil-exclamation-triangle"></i>
                          </button>
                          <b-dropdown variant="primary" size="sm">
                            <template slot="button-content">
                              REORDER
                              <i class="uil uil-angle-down"></i>
                            </template>
                            <b-dropdown-item @click="reorderData('export')"
                              >EXPORT</b-dropdown-item
                            >
                            <b-dropdown-item @click="reorderData('import')"
                              >IMPORT</b-dropdown-item
                            >
                          </b-dropdown>
                          <button
                            class="btn btn-sm btn-primary"
                            title="Download"
                            @click="downloadFile"
                          >
                            DOWNLOAD
                          </button>
                          <button
                            class="btn btn-sm btn-primary"
                            title="Download"
                            @click="
                              modalComponent = 'TaosTads'
                              showModal = true
                            "
                          >
                            TAOs & TADs
                          </button>
                        </div>
                      </div>
                      <div class="col-md-6 text-right">
                        <button
                          v-if="requestType === 'LCL'"
                          type="button"
                          class="btn btn-sm btn-danger col-4"
                          @click="confirmFinish"
                          ><strong>
                            Finish mapping
                            <i class="uil uil-file-check-alt"></i> </strong
                        ></button>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <hot-table
                          ref="wrapper"
                          :settings="hotSettings"
                        ></hot-table>
                      </div>
                    </div>
                  </div>
                  <div
                    v-else
                    class="row align-items-center justify-content-center"
                    style="height: 300px"
                  >
                    <div class="col-12 col-md-8 text-center">
                      <feather
                        type="frown"
                        class="icon-xxl icon-dual-info"
                      ></feather>
                      <h6 class="text-muted">{{ error }}</h6>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab
                v-if="requestType === 'FCL'"
                title="SUGGESTED SURCHARGES"
                :disabled="!tableSuccess"
                @click="getSurchargeSuggestions"
              >
                <div
                  v-if="suggestionsTab.loading"
                  class="row align-items-center justify-content-center"
                  style="height: 300px"
                >
                  <div class="col-12 col-md-8 text-center">
                    <b-spinner
                      label="Loading..."
                      variant="primary"
                      class="ml-3"
                    ></b-spinner>
                  </div>
                </div>

                <div
                  v-else-if="!suggestionsTab.success"
                  class="row align-items-center justify-content-center"
                  style="height: 300px"
                >
                  <div class="col-12 col-md-8 text-center">
                    <feather
                      type="frown"
                      class="icon-xxl icon-dual-info"
                    ></feather>
                    <h6 class="text-muted">{{ suggestionsTab.error }}</h6>
                    <button
                      class="btn btn-sm btn-outline-warning my-0"
                      title="Add Surchargers Manualy"
                      @click="addSurchargeManually"
                    >
                      Add Surchargers Manualy
                    </button>
                    &nbsp;
                    <button
                      class="btn btn-sm btn-outline-info my-0"
                      title="Similar contracts"
                      @click="
                        modalComponent = 'similars'
                        showModal = true
                      "
                    >
                      Check Information
                    </button>
                  </div>
                </div>

                <div v-else>
                  <div class="row mb-5">
                    <div class="col-12 col-md-8 d-flex align-items-center">
                      <button
                        class="btn btn-sm btn-primary my-0 mr-2"
                        title="Similar contracts"
                        @click="
                          modalComponent = 'similars'
                          showModal = true
                        "
                      >
                        <i class="uil uil-info-circle"></i>
                      </button>
                      <ul class="info-ss">
                        <li
                          ><span class="mr-4"
                            ><b>ID:</b> {{ dataSuggested.contract }}</span
                          ></li
                        >
                        <li
                          ><span class="mr-4"
                            ><b>Carrier:</b>
                            {{ dataSuggested.carrier.name }}</span
                          ></li
                        >
                        <li
                          ><span class="mr-4"
                            ><b>Direction:</b>
                            {{ dataSuggested.direction.name }}</span
                          ></li
                        >
                        <li
                          ><span class="mr-4"
                            ><b>Total Contract:</b>
                            {{ dataSuggested.similar }}</span
                          ></li
                        >
                      </ul>
                      <b-button-group v-if="showOptionsSelectedSurcharges">
                        <b-button
                          @click="duplicateSurcharge"
                          variant="outline-primary"
                          size="sm"
                          ><i class="uil uil-copy"></i> Duplicate</b-button
                        >
                        <b-button
                          @click="deleteSurcharge(null)"
                          variant="outline-danger"
                          size="sm"
                          ><i class="uil uil-trash"></i> Delete</b-button
                        >
                      </b-button-group>
                    </div>
                    <div class="col-6 col-md-4">
                      <button
                        class="btn btn-sm btn-primary btn-add-surcharge"
                        v-on:click="addNewSurcharge"
                      >
                        <i class="uil uil-plus"></i>
                        Add Surcharge
                      </button>
                    </div>
                  </div>

                  <div class="table-responsive table-responsive-suggested">
                    <table class="table m-0 table-suggested">
                      <thead>
                        <tr>
                          <th>
                            <b-form-checkbox
                              v-model="allSelectedSurcharge"
                              :indeterminate="false"
                              aria-describedby="flavours"
                              aria-controls="flavours"
                              @change="allSurcharges"
                            >
                            </b-form-checkbox>
                          </th>
                          <th>Charge</th>
                          <th>Type Destiny</th>
                          <th>Differentatior</th>
                          <th>Origin</th>
                          <th>Destination</th>
                          <th>Calculation type</th>
                          <th>Value</th>
                          <th>Currency</th>
                          <th>Coincidence</th>
                          <th>Frequency</th>
                          <th>L. Lower</th>
                          <th>L. Upper</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- Data -->
                        <tr
                          v-for="(data, key) in dataSuggested.suggested"
                          :key="key"
                          :id="key"
                        >
                          <td>
                            <b-form-checkbox
                              :id="'surcharge-' + key"
                              :value="key"
                              v-model="selectedSurcharge"
                              @click="test(key)"
                            >
                            </b-form-checkbox>
                          </td>
                          <td>
                            <b-form-input
                              v-if="data['charge']"
                              v-model="data['charge']"
                              class="bc-input"
                              :style="'border: 2px solid '+data['detail_charge']['color']"
                              :title="data['detail_charge']['info']"
                            >
                            </b-form-input>

                            <v-select
                              v-else
                              v-model="data['charge']"
                              label="name"
                              :filterable="false"
                              :options="options"
                              @search="onSearch"
                            >
                              <template slot="no-options">
                                Type to search...
                              </template>
                            </v-select>
                          </td>
                          <td>
                            <v-select
                              v-model="data['destination_type']"
                              :options="dataTypeDestination"
                              label="name"
                              class="bc-input"
                            >
                              <template slot="no-options">
                                Type to search...
                              </template>
                            </v-select>
                          </td>
                          <td>
                            <v-select
                              v-model="data['DIFFERENTIATOR']"
                              :options="dataSuggested.places"
                              @input="changeType(key)"
                              class="bc-input"
                            >
                              <template slot="no-options">
                                Type to search...
                              </template>
                            </v-select>
                          </td>
                          <td>
                            <b-button
                              @click="
                                showModalPlace(key, 'ORIGIN', data['ORIGIN'])
                              "
                              class="btn-modal-suggested"
                            >
                              <span v-if="data['ORIGIN'][0].name == null"
                                >Select a {{ data['DIFFERENTIATOR'] }}</span
                              >
                              <span v-else
                                >{{ data['ORIGIN'][0].name }}
                                <span v-if="data['ORIGIN']"
                                  >+ {{ data['ORIGIN'].length - 1 }}</span
                                ></span
                              >
                            </b-button>
                          </td>
                          <td>
                            <b-button
                              @click="
                                showModalPlace(key, 'DESTINY', data['DESTINY'])
                              "
                              class="btn-modal-suggested"
                            >
                              <span v-if="data['DESTINY'][0].name == null"
                                >Select a {{ data['DIFFERENTIATOR'] }}</span
                              >
                              <span v-else
                                >{{ data['DESTINY'][0].name }}
                                <span v-if="data['DESTINY']"
                                  >+ {{ data['DESTINY'].length - 1 }}</span
                                ></span
                              >
                            </b-button>
                          </td>
                          <td>
                            <v-select
                              v-model="data.calculationType"
                              :options="dataSuggested['calculation_types']"
                              :label="'name'"
                              class="bc-input"
                            >
                              <template slot="no-options">
                                Type to search...
                              </template>
                            </v-select>
                          </td>
                          <td>
                            <b-form-input
                              v-model="data['amount_mean']"
                              class="form-control bc-input form-control-sm ml-2"
                            >
                            </b-form-input>
                          </td>
                          <td>
                            <v-select
                              v-model="data.currency"
                              :options="dataSuggested.currencies"
                              :label="'name'"
                              class="bc-input"
                            >
                              <template slot="no-options">
                                Type to search...
                              </template>
                            </v-select>
                          </td>
                          <td v-if="data.count == 'N/A'" class="data-fixed"
                            >N/A</td
                          >
                          <td v-else class="data-fixed"
                            >{{ 100 - Math.ceil(data.amount_cv * 100) }}%</td
                          >
                          <td v-if="data.count == 'N/A'" class="data-fixed"
                            >N/A</td
                          >
                          <td v-else class="data-fixed"
                            >{{ data.count }}/{{ dataSuggested.similar }}</td
                          >
                          <td>
                            <b-form-input
                              v-model="data['lower_limit']"
                              class="form-control bc-input form-control-sm ml-2"
                            >
                            </b-form-input>
                          </td>
                          <td>
                            <b-form-input
                              v-model="data['upper_limit']"
                              class="form-control bc-input form-control-sm ml-2"
                            >
                            </b-form-input>
                          </td>
                          <td>
                            <b-dropdown
                              text="..."
                              class="action-dropdown m-md-2"
                              right
                              id="dropdown-right"
                            >
                              <b-dropdown-item @click="duplicateSurcharge(key)"
                                ><i class="uil uil-copy"></i>
                                Duplicate</b-dropdown-item
                              >
                              <b-dropdown-item @click="deleteSurcharge(key)"
                                ><i class="uil uil-trash"></i>
                                Delete</b-dropdown-item
                              >
                            </b-dropdown>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <b-button
                  class="btn btn-sm btn-success btn-add-surcharge"
                  size="lg"
                  @click="saveSuggested"
                >
                  Save Surcharge
                </b-button>
                &nbsp;
                <b-button
                  v-if="requestType === 'FCL'"
                  type="button"
                  class="btn btn-sm btn-danger btn-add-surcharge"
                  size="lg"
                  @click="confirmFinish"
                  ><strong>
                    Finish mapping
                    <i class="uil uil-file-check-alt"></i> </strong
                ></b-button>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Harbor-Manager -->
    <b-modal
      id="modal-lg"
      v-model="showModal"
      centered
      size="md"
      :title="modalTitle[modalComponent]"
      :hide-footer="true"
    >
      <HarborManager v-if="modalComponent === 'HarborManager'" />
      <addCountry
        v-if="modalComponent === 'addCountry'"
        :ad-options="addCountryOptions"
      />

      <div v-else-if="modalComponent === 'TaosTads'" class="col-12">
        <div class="row">
          <div class="col-xl-6 col-sm-6">
                <div class="form-group mt-3 mt-sm-0">
                  <label for="default">Select Item By</label>
                  <multiselect v-model="selectTaoTadBy" :options="['MIN','MAX']"></multiselect>
                </div>
              </div>
          <div class="col-xl-6 col-sm-6">
            <b-button
                  type="button"
                  class="btn  btn-primary btn-add-surcharge mt-4 form-control"
                  size="lg"
                  @click="processTaosTads"
                  >
                    Process
                    <i class="uil uil-file-check-alt"></i> </b-button>
        </div>
        </div>
      </div>

      <div v-else-if="modalComponent === 'Messages'" class="row">
        <div v-if="postprocessingMessages.length > 0" class="col-12">
          <div class="row" style="height: 300px; overflow-y: scroll">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table table-striped mb-0">
                  <tbody>
                    <tr
                      v-for="(message, index) in postprocessingMessages"
                      :key="index"
                    >
                      <th scope="row">{{ index }}</th>
                      <td scope="row">{{ message }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="col-12">
          <div
            class="row align-items-center justify-content-center"
            style="height: 350px"
          >
            <div class="col-12 col-md-8 text-center">
              <feather
                type="thumbs-up"
                class="icon-xxl icon-dual-info"
              ></feather>
              <h6 class="text-muted">There is no messages</h6>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="modalComponent === 'Details'" class="row">
        <div class="col-4">
          <h6 class="mb-1">Request ID:</h6>
          <p>{{ contract.id }}</p>
        </div>
        <div class="col-4">
          <h6 class="mb-1">Name:</h6>
          <p>{{ contract.name }}</p>
        </div>
        <div class="col-4">
          <h6 class="mb-1">Created at:</h6>
          <p>{{ contract.created }}</p>
        </div>
        <div class="col-4">
          <h6 class="mb-1">Validation:</h6>
          <p>{{ contract.validation }}</p>
        </div>
        <div class="col-4">
          <h6 class="mb-1">Direction:</h6>
          <p>{{ contract.direction }}</p>
        </div>
        <div class="col-4">
          <h6 class="mb-1">Status:</h6>
          <p>{{ contract.status }}</p>
        </div>
        <div class="col-4">
          <h6 class="mb-1">Company User:</h6>
          <p>{{ contract.company }}</p>
        </div>
        <div class="col-4">
          <h6 class="mb-1">User:</h6>
          <p>{{ contract.user }}</p>
        </div>
        <div class="col-4">
          <h6 class="mb-1">Operator:</h6>
          <p>{{ contract.operator }}</p>
        </div>
      </div>

      <div v-else-if="modalComponent === 'similars'" class="row">
        <div class="col mb-2">
          <p>Current trades: {{ suggestionsTab.numTrades }}</p>
        </div>
        <div v-if="suggestionsTab.similarContracts.length > 0" class="col-12">
          <div
            v-for="c in suggestionsTab.similarContracts"
            :key="c.contrac_id"
            class="row"
          >
            <div class="col-12">
              <h6>Request ID: {{ c.request_id }}</h6>
            </div>
            <div class="col">
              <p> Found trades: {{ c.found_trades }} </p>
            </div>
            <div class="col">
              <p> Total trades: {{ c.total_trades }} </p>
            </div>
          </div>
        </div>
        <div v-else class="col-12 my-3">
          <p> Did not find any similar contract. :(</p>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-save" hide-footer>
      <template #modal-title> Guardar Sugerencia </template>
      <div class="d-block">
        <p>¿Estas seguro de que quieres guardar la sugerencia?</p>
      </div>

      <div class="d-flex justify-content-end align-items-center">
        <b-button
          variant="outline-danger"
          class="mr-1"
          @click="$bvModal.hide('modal-save')"
          >Cancel</b-button
        >
        <b-button variant="primary">Save</b-button>
      </div>
    </b-modal>
  </Layout>
</template>

<style scoped>
.my-custom-scrollbar {
  position: relative;
  height: 580px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #7d7c7d;
}

.action-dropdown .dropdown-toggle {
  color: #333333;
  border: 2px solid #777777;
  border-radius: 3px;
  width: 25px;
  height: 25px;
  padding: 0px;
  font-weight: 900;
  background: transparent;
}
</style>